var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 10,
    viewBox: "0 0 35 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 10,
    fill: "#8FD700",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.966 5.137c0 .945-.234 1.672-.703 2.18-.469.507-1.14.761-2.016.761-.875 0-1.546-.254-2.015-.762-.469-.507-.703-1.237-.703-2.187 0-.95.235-1.677.705-2.178.47-.501 1.144-.752 2.021-.752.878 0 1.549.253 2.014.758.465.505.697 1.232.697 2.18zm-4.168 0c0 .638.121 1.118.363 1.441.243.323.605.484 1.086.484.967 0 1.45-.641 1.45-1.925 0-1.287-.48-1.93-1.442-1.93-.482 0-.845.162-1.09.486-.244.325-.367.806-.367 1.444zM14.751 8h-1.38l-.773-3a14.604 14.604 0 0 1-.146-.662 7.558 7.558 0 0 1-.12-.674 8.87 8.87 0 0 1-.116.678c-.063.311-.111.533-.145.666L11.301 8H9.928L8.47 2.29h1.19l.731 3.116c.128.576.22 1.074.278 1.496.015-.148.051-.378.107-.69.056-.31.109-.552.158-.724l.832-3.199h1.145l.832 3.2c.036.143.082.361.137.656.054.294.096.546.125.757.026-.203.067-.456.125-.76.057-.303.11-.548.156-.736l.727-3.117h1.19L14.752 8zm7.355 0h-1.54l-2.484-4.32h-.035c.05.763.074 1.307.074 1.632V8H17.04V2.29h1.528l2.48 4.276h.027a34.631 34.631 0 0 1-.058-1.574V2.29h1.09V8zm4.843 0h-3.29V2.29h3.29v.991h-2.078v1.254h1.933v.992h-1.933V7h2.078v1zm2.519-3.176h.39c.383 0 .666-.064.848-.191.183-.128.274-.328.274-.602 0-.27-.093-.463-.28-.578-.186-.114-.474-.172-.865-.172h-.367v1.543zm0 .985V8h-1.211V2.29h1.664c.776 0 1.35.14 1.723.423.372.282.558.711.558 1.287 0 .336-.092.635-.277.896a1.835 1.835 0 0 1-.785.616C32 6.796 32.56 7.625 32.82 8h-1.344l-1.364-2.191h-.644z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerTag);
export default __webpack_public_path__ + "static/media/owner_tag.07fffd25ee1bb0057b464e80da1650ba.svg";
export { ForwardRef as ReactComponent };